export interface SdgGoal {
    number: number
    title: string
    color: string
}

export const sdgGoals: SdgGoal[] = [
    { number: 1, title: 'sdg_goal_1', color: '#E5243B' },
    { number: 2, title: 'sdg_goal_2', color: '#DDA63A' },
    { number: 3, title: 'sdg_goal_3', color: '#4C9F38' },
    { number: 4, title: 'sdg_goal_4', color: '#C5192D' },
    { number: 5, title: 'sdg_goal_5', color: '#FF3A21' },
    { number: 6, title: 'sdg_goal_6', color: '#26BDE2' },
    { number: 7, title: 'sdg_goal_7', color: '#FCC30B' },
    { number: 8, title: 'sdg_goal_8', color: '#A21942' },
    { number: 9, title: 'sdg_goal_9', color: '#FD6925' },
    { number: 10, title: 'sdg_goal_10', color: '#DD1367' },
    { number: 11, title: 'sdg_goal_11', color: '#FD9D24' },
    { number: 12, title: 'sdg_goal_12', color: '#BF8B2E' },
    { number: 13, title: 'sdg_goal_13', color: '#3F7E44' },
    { number: 14, title: 'sdg_goal_14', color: '#0A97D9' },
    { number: 15, title: 'sdg_goal_15', color: '#56C02B' },
    { number: 16, title: 'sdg_goal_16', color: '#00689D' },
    { number: 17, title: 'sdg_goal_17', color: '#19486A' },
]
